import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
// Lazy load below-the-fold sections
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const TomosDetail = lazy(() => import('./components/TomosDetail').then(m => ({
  default: m.TomosDetail
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const AcceleratorComparison = lazy(() => import('./components/AcceleratorComparison').then(m => ({
  default: m.AcceleratorComparison
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-accent selection:text-white" data-id="element-0">
      {/* Above the fold — loaded eagerly */}
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials limit={3} data-id="element-3" />

      {/* Below the fold — lazy loaded */}
      <Suspense fallback={null} data-id="element-4">
        <PainPoints data-id="element-5" />
        <ProductOverview data-id="element-6" />
        <TomosDetail data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Pricing id="pricing" data-id="element-9" />
        <AcceleratorComparison data-id="element-10" />
        <Testimonials className="pt-8" data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostComparison data-id="element-14" />
        <Pricing data-id="element-15" />

        <div className="flex flex-wrap justify-center gap-6 text-sm text-neutral-400 font-medium pb-16 px-4" data-id="element-16">
          <span className="flex items-center gap-2" data-id="element-17">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-2" data-id="element-18">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-19">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-2" data-id="element-20">
            💳 Tarjeta — Bizum — Transferencia
          </span>
        </div>

        <Footer data-id="element-21" />
      </Suspense>
    </div>;
}